import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startDelete } from '../../redux/actions/exchangeRate';
import { uiManageModalNotification } from '../../redux/actions/ui';
import { Content } from './Content';

export const ConfirmDeleteExchangeRate = () => {
  const dispatch = useDispatch(); //react-redux hook to be able to dispatch the actions
  const { active } = useSelector(state => state.exchangeRate); //we get the users from the state

  const handleSuccess = () => {
    dispatch(uiManageModalNotification());
    dispatch(startDelete(active.PkTiposCambioProveedores)); //We dispatch the action passing as a parameter the user id
  };

  //The HTML is being rendered
  return (
    <Content
      title={`¿Quieres borrar el tipo de cambio?`}
      text={`El tipo de cambio quedará eliminado definitivamente del sistema`}
      action={handleSuccess}
    />
  );
};
